import { render, staticRenderFns } from "./KeyValuesForm.vue?vue&type=template&id=0f04d790&scoped=true"
import script from "./KeyValuesForm.vue?vue&type=script&lang=js"
export * from "./KeyValuesForm.vue?vue&type=script&lang=js"
import style0 from "./KeyValuesForm.vue?vue&type=style&index=0&id=0f04d790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04d790",
  null
  
)

export default component.exports